module.exports = __webpack_public_path__ + "img/lines.5f7b97d2.svg";